<template>
    <box :hideable="true">
        <h3 slot="header">
            <i class="fas fa-file-medical-alt"></i> Logs
        </h3>
        <div slot="body">
            <data-table class="table table-striped"
                :columns="columns"
                :data="logs"
                :loading="loading"
                :datatableOptions="{ order: [[ 0, 'desc' ]] }"
            />
        </div>
    </box>
</template>

<script>

const logStatus = {
    ok: 1,
    error: 2, 
    warning: 3
}

import api from '../api';

import BootstrapBox from '../../../Components/Util/BootstrapBox.vue';
import DataTable from '../../../Components/Util/DataTable/DataTable.vue';
import { bootstrapDangerGrowl } from '../../../Util/growler';
import { dateToString } from '../../../Util/time';

import guid from '../../../Util/Mixins/guid';

export default {
    name: 'operator-test-logs',
    mixins: [guid],
    components: {
        'Box': BootstrapBox,
        DataTable
    },
    methods: {
        load(schemeId) {
            const vm = this;
            vm.loading = true;
            api.getLogs(schemeId).then(
                (logs) => {
                    vm.logs = logs.filter((log) => 
                        log.brickId !== vm.emptyGuid() || log.status !== 1
                    ).map((log) => {
                        return {
                            date: dateToString(log.startDate),
                            duration: log.duration,
                            runId: log.operatorRunId,
                            brickId: log.brickId,
                            status: vm.status(log.status),
                            info: log.debugInfo,
                            inputData: log.inputData
                        };
                    });
                    
                    vm.loading = false;
                },
                bootstrapDangerGrowl
            );
        },
        status(status) {
            const keys = Object.keys(logStatus);
            let value;

            for(let i = 0 ; i < keys.length ; i++ ) {
                if(logStatus[keys[i]] === status) {
                    value = keys[i];
                    break;
                }
            }

            return value;
        }
    },
    data() {
        return {
            loading: false,
            logs: [],
            columns: [
                { title: 'Start date', data: 'date' },
                { title: 'Duration', data: 'duration' },
                { title: 'Run Id', data: 'runId' },
                { title: 'Brick Id', data: 'brickId' },
                { title: 'Status', data: 'status' },
                { title: 'Info', data: 'info', width: '200px'},
                { title: 'Input Data', data: 'inputData', width: '200px' }
            ],
        };
    }
};
</script>

<style lang="scss" scoped>

</style>